import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Incomplete14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_115)'>
      <path
        d='M6.99999 1.75C9.89949 1.75 12.25 4.1005 12.25 7C12.25 9.8995 9.89949 12.25 6.99999 12.25C6.64841 12.25 6.30562 12.2155 5.97457 12.1501L5.68347 13.6215C6.10987 13.7059 6.55015 13.75 6.99999 13.75C10.7279 13.75 13.75 10.7279 13.75 7C13.75 3.27208 10.7279 0.25 6.99999 0.25C6.55015 0.25 6.10987 0.294109 5.68347 0.378463L5.97457 1.84995C6.30562 1.78445 6.64841 1.75 6.99999 1.75Z'
        fill='currentColor'
      />
      <path
        d='M1.38737 10.7509C1.87996 11.4867 2.51329 12.12 3.24906 12.6126L4.08354 11.3662C3.51069 10.9827 3.01734 10.4893 2.63383 9.91646L1.38737 10.7509Z'
        fill='currentColor'
      />
      <path
        d='M3.24906 1.38738C2.51328 1.87997 1.87996 2.51329 1.38737 3.24907L2.63382 4.08355C3.01733 3.5107 3.51069 3.01734 4.08354 2.63383L3.24906 1.38738Z'
        fill='currentColor'
      />
      <path
        d='M0.378456 5.68348C0.209745 6.53628 0.209745 7.46372 0.378456 8.31652L1.84994 8.02542C1.71896 7.36333 1.71896 6.63667 1.84994 5.97458L0.378456 5.68348Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_115'>
        <rect
          width='14'
          height='14'
          fill='white'
          transform='matrix(0 1 -1 0 14 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Incomplete14.displayName = 'Incomplete14';
export default Incomplete14;
